/**
 * 可以在此地扩展vue方法 以便你更好的使用它
 */
const fine = {
    $calcHeight: () => {
        // const $ = window.$;
        // const calcHeight = $('.vue-app').height() - $('.header').height();
        // $('.drizzle-content').height(calcHeight);
    },
    // 切换到drizzlejs框架，隐藏vue框架后的回调
    $vueHided() {
        // 移除个人中心模块的全局样式
        window.$('body').removeClass('mix-vue-center');
    },
    // 修复ant-select-dropdown 选中状态显示有误 bug号：83693...
    $fixDropdown() {
        setTimeout(() => {
            window.jQuery('.ant-select-dropdown-menu-item').removeClass('ant-select-dropdown-menu-item-active');
        }, 0);
    }
};

const useful = {
    install(Vue) {
        Object.keys(fine).forEach((key) => {
            Vue.prototype[key] = fine[key];
        });
    }
};

export default useful;
